<template>
  <span>
    <dashboard-lno-visao-aneel-indicadores
      :dados-totais="dadosTotais"
      :dados-totais-competencia-anterior="dadosTotaisCompetenciaAnterior"
      :traducao-indicadores="traducaoIndicadores"
      :loading="loadingPorChave.dadosTotais"
    />

    <dashboard-lno-visao-aneel-kpis :cards="cardHighchartsKpisComputed" />

    <v-row dense justify="center" class="mb-4">
      <v-col cols="12">
        <v-card class="pa-4 elevation-1">
          <v-row align="center">
            <v-col cols="12" md="9">
              <filtro-data-range
                v-model="filtroData"
                :data-minima="'2023-01-01'"
                :data-maxima="dataAtual"
              />
            </v-col>

            <v-col
              cols="12"
              md="3"
              class="d-flex justify-center justify-md-end"
            >
              <v-btn
                color="primary"
                block
                height="48"
                :loading="isFetching"
                :disabled="isFetching"
                @click="getDados"
              >
                <v-icon left>mdi-magnify</v-icon>
                Consultar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <dashboard-lno-visao-aneel-charts :cards="cardChartDataComputed" />
  </span>
</template>

<script>
import DashboardLnoService from "@/services/DashboardLnoService";
import MunicipiosService from "@/services/MunicipiosService";
import FiltroDataRange from "@/components/dashboardLno/FiltroDataRange.vue";

import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);

import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
exporting(Highcharts);
exportData(Highcharts);

import dayjs from "dayjs";
import { periodoPadrao } from "@/utils/periodoDashboardLno";

export default {
  name: "DashboardLnoVisaoAneel",
  components: {
    DashboardLnoVisaoAneelIndicadores: () =>
      import("@/components/dashboardLno/DashboardLnoVisaoAneelIndicadores.vue"),
    DashboardLnoVisaoAneelKpis: () =>
      import("@/components/dashboardLno/DashboardLnoVisaoAneelKpis.vue"),
    DashboardLnoVisaoAneelCharts: () =>
      import("@/components/dashboardLno/DashboardLnoVisaoAneelCharts.vue"),

    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
    FiltroDataRange,
  },
  props: {
    competencia: {
      type: String,
      required: true,
    },
    tipoCalculo: {
      type: String,
      required: true,
    },
    tipoLocalizacao: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    activatedTab: {
      type: Number,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: {},
    },
    regionalSelecionadaId: {
      type: Number,
      default: 0,
    },
    categoriesResultadoAtual: {
      type: Array,
    },
    categoriesResultadoAnterior: {
      type: Array,
    },
  },
  data: () => ({
    eixoIndicadores: [],
    eixoEntrantesConcluidos: [],
    dadosQlpMultiSeries: {},
    dataAtual: dayjs().format("YYYY-MM"),
    filtroData: periodoPadrao(),
    chartRefNames: [
      "chartOptionsSituacaoSolicitacoesObras",
      "chartOptionsSituacaoSolicitacoesOrcamentos",
      "chartOptionsTipologiasSolicitacoes",
      "chartOptionsLocSolicitacoes",
      "chartOptionsLocSolicitacoesEmAtraso",
      "chartOptionsTipologiasSolicitacoesEmAtraso",
      "chartOptionsQlpLno",
      "chartOptionsPlaLno",
      "chartOptionsQla",
      "chartOptionsQlt",
      "chartOptionsPat1Lno",
      "chartOptionsPat1QuantidadeLigacoesAtrasadas",
      "chartOptionsPat2Lno",
      "chartOptionsPat2QuantidadeLigacoesAtrasadas",
      "chartOptionsPat3Lno",
      "chartOptionsPat3QuantidadeLigacoesAtrasadas",
      "chartOptionsPat4Lno",
      "chartOptionsPat4QuantidadeLigacoesAtrasadas",
      "chartOptionsPmea15Lno",
      "chartOptionsPmea30Lno",
      "chartOptionsPmea45Lno",
      "chartOptionsEntrantesConcluidos",
      "chartOptionsPSFP",
    ],
    dadosPorCompetencia: {},
    metasKpis: {},
    dadosTotais: {},
    dadosTotaisCompetenciaAnterior: {},
    dadosLocSolicitacoes: [],
    dadosTipologiasSolicitacoes: [],
    dadosSituacaoSolicitacoes: [],
    dadosQlpMultiSeries: [],
    dadosEntrantesConcluidos: {},
    chartOptionsLocSolicitacoes: {},
    chartOptionsLocSolicitacoesEmAtraso: {},
    chartOptionsTipologiasSolicitacoes: {},
    chartOptionsTipologiasSolicitacoesEmAtraso: {},
    chartOptionsSituacaoSolicitacoesObras: {},
    chartOptionsSituacaoSolicitacoesOrcamentos: {},
    chartOptionsQlpMultiSeries: {},
    chartOptionsQlt: {},
    chartOptionsQlpLno: {},
    chartOptionsPlaLno: {},
    chartOptionsPmea15Lno: {},
    chartOptionsPmea30Lno: {},
    chartOptionsPmea45Lno: {},
    chartOptionsEntrantesConcluidos: {},
    chartOptionsPat1Lno: {},
    chartOptionsPat1QuantidadeLigacoesAtrasadas: {},
    chartOptionsPat2Lno: {},
    chartOptionsPat2QuantidadeLigacoesAtrasadas: {},
    chartOptionsPat3Lno: {},
    chartOptionsPat3QuantidadeLigacoesAtrasadas: {},
    chartOptionsPat4Lno: {},
    chartOptionsPat4QuantidadeLigacoesAtrasadas: {},
    chartOptionsQla: {},
    chartOptionsPSFP: {},
    exportingOptions: {
      enabled: true,

      buttons: {
        contextButton: {
          align: "left",
          verticalAlign: "bottom",
          menuItems: [
            {
              textKey: "downloadPNG",
              text: "Baixar como PNG",
              onclick: function() {
                this.exportChart();
              },
            },
            {
              separator: true,
            },
            {
              textKey: "downloadCSV",
              text: "Baixar como CSV",
              onclick: function() {
                this.downloadCSV();
              },
            },
            {
              textKey: "downloadXLS",
              text: "Baixar como XLS",
              onclick: function() {
                this.downloadXLS();
              },
            },
          ],
        },
      },
    },
    loadingPorChave: {
      dadosTotais: false,
      dadosPorCompetencia: false,
      metasKpis: false,
      localizacaoSolicitacoes: false,
      tipologiasSolicitacoes: false,
      situacaoSolicitacoes: false,
      qlpMultiSeries: false,
      qlt: false,
      entrantesConcluidos: false,
    },
    isFetching: false,
    cardHighchartsKpis: [
      {
        title: "Situação das Solicitações - Obras",
        highchartsOptionsAndRef: "chartOptionsSituacaoSolicitacoesObras",
        deepCopyOnUpdate: false,
        loadingKey: "situacaoSolicitacoes",
      },
      {
        title: "Situação das Solicitações - Orçamentos",
        highchartsOptionsAndRef: "chartOptionsSituacaoSolicitacoesOrcamentos",
        deepCopyOnUpdate: false,
        loadingKey: "situacaoSolicitacoes",
      },
      {
        title: "Tipologias das Solicitações",
        highchartsOptionsAndRef: "chartOptionsTipologiasSolicitacoes",
        deepCopyOnUpdate: false,
        loadingKey: "tipologiasSolicitacoes",
      },
      {
        title: "Localização das Obras",
        highchartsOptionsAndRef: "chartOptionsLocSolicitacoes",
        deepCopyOnUpdate: false,
        loadingKey: "localizacaoSolicitacoes",
      },
      {
        title: "Localização das Obras em Atraso",
        highchartsOptionsAndRef: "chartOptionsLocSolicitacoesEmAtraso",
        deepCopyOnUpdate: false,
        loadingKey: "localizacaoSolicitacoes",
      },
      {
        title: "Tipologias das Solicitações em Atraso",
        highchartsOptionsAndRef: "chartOptionsTipologiasSolicitacoesEmAtraso",
        deepCopyOnUpdate: false,
        loadingKey: "tipologiasSolicitacoes",
      },
    ],
    cardChartData: [
      {
        title: "QLP - Qtde. de Ligações com obra pendentes não suspensas",
        highchartsOptionsAndRef: "chartOptionsQlpLno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PLA - Percentual de ligações com obra atrasadas",
        highchartsOptionsAndRef: "chartOptionsPlaLno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "QLA - Qtde. de Ligações Atrasadas",
        highchartsOptionsAndRef: "chartOptionsQla",
        deepCopyOnUpdate: true,
        loadingKey: "qlpMultiSeries",
      },
      {
        title: "QLT - Qtde. de Ligações Totais (pendentes + suspensas)",
        highchartsOptionsAndRef: "chartOptionsQlt",
        deepCopyOnUpdate: true,
        loadingKey: "qlt",
      },
      {
        title: "PAT1 - Prazo Médio de Lig. Atrasada do Tipo 1",
        highchartsOptionsAndRef: "chartOptionsPat1Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT1 - Quantidade de ligações atrasadas do Tipo 1",
        highchartsOptionsAndRef: "chartOptionsPat1QuantidadeLigacoesAtrasadas",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT2 - Prazo Médio de Lig. Atrasada do Tipo 2",
        highchartsOptionsAndRef: "chartOptionsPat2Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT2 - Quantidade de ligações atrasadas do Tipo 2",
        highchartsOptionsAndRef: "chartOptionsPat2QuantidadeLigacoesAtrasadas",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT3 - Prazo Médio de Lig. Atrasada do Tipo 3",
        highchartsOptionsAndRef: "chartOptionsPat3Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT3 - Quantidade de ligações atrasadas do Tipo 3",
        highchartsOptionsAndRef: "chartOptionsPat3QuantidadeLigacoesAtrasadas",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT4 - Prazo Médio de Lig. Atrasada do Tipo 4",
        highchartsOptionsAndRef: "chartOptionsPat4Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PAT4 - Quantidade de ligações atrasadas do Tipo 4",
        highchartsOptionsAndRef: "chartOptionsPat4QuantidadeLigacoesAtrasadas",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PMEA15 - Prazo Médio de Estudos Atrasados (15 dias)",
        highchartsOptionsAndRef: "chartOptionsPmea15Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PMEA30 - Prazo Médio de Estudos Atrasados (30 dias)",
        highchartsOptionsAndRef: "chartOptionsPmea30Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "PMEA45 - Prazo Médio de Estudos Atrasados (45 dias)",
        highchartsOptionsAndRef: "chartOptionsPmea45Lno",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
      {
        title: "Entrantes vs Concluídos",
        highchartsOptionsAndRef: "chartOptionsEntrantesConcluidos",
        deepCopyOnUpdate: true,
        loadingKey: "entrantesConcluidos",
      },
      {
        title:
          "PSFP - Percentual de Serviços Atendidos Após o Prazo Regulatório",
        highchartsOptionsAndRef: "chartOptionsPSFP",
        deepCopyOnUpdate: true,
        loadingKey: "dadosPorCompetencia",
      },
    ],
  }),
  computed: {
    competenciaDe() {
      return this.filtroData.dataInicio;
    },
    competenciaAte() {
      return this.filtroData.dataFim;
    },
    cardChartDataComputed() {
      return this.cardChartData.map((card) => {
        return {
          ...card,
          options: this[card.highchartsOptionsAndRef],
          ref: card.highchartsOptionsAndRef,
          loading: !!this.loadingPorChave[card.loadingKey],
        };
      });
    },
    cardHighchartsKpisComputed() {
      // kpis
      return this.cardHighchartsKpis.map((card) => {
        return {
          ...card,
          options: this[card.highchartsOptionsAndRef],
          ref: card.highchartsOptionsAndRef,
          loading: !!this.loadingPorChave[card.loadingKey],
        };
      });
    },
  },
  mounted() {
    this.getDados();
  },
  methods: {
    getNomeFromEixo(eixo = []) {
      const anos = [
        ...new Set((eixo || []).map((item) => item.ano).filter(Boolean)),
      ];

      if (!anos.length) return "";
      if (anos.length === 1) return String(anos[0]);

      return `${anos[0]}-${anos[anos.length - 1]}`;
    },

    buildDataSeriesFromBackend(name, data = []) {
      return {
        name,
        animation: false,
        data: (data || []).filter(
          (val) =>
            val !== null &&
            val.y !== null &&
            Number.isFinite(val.y) &&
            val.y >= 0,
        ),
      };
    },
    getLabelsFromEixo(eixo = []) {
      return (eixo || []).map((item) => item.label);
    },
    getAnoFromEixo(eixo = []) {
      return eixo?.[0]?.ano ? String(eixo[0].ano) : "";
    },
    scheduleGetDados() {
      this.getDados();
    },
    getDados() {
      // Apenas atualizado os dados se for a visao selecionada
      if (this.activatedTab !== 1) return;
      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      this.$emit("updateLoadingDados", true);

      const promises = [
        this.getDadosTotais(),
        this.getDadosTotaisCompetenciaAnterior(),
        this.getDadosPorCompetencia(),
        this.getMetasKpisGeral(),
        this.getDadosLocalizacaoSolicitacoes(),
        this.getDadosTipologiasSolicitacoes(),
        this.getDadosSituacaoSolicitacoes(),
        this.getDadosQlpMultiSeries(),
        this.getDadosQlt(),
        this.getDadosEntrantesConcluidos(),
      ];

      Promise.allSettled(promises)
        .then((results) => {
          const hasError = results.some((r) => r.status === "rejected");
          if (hasError) {
            this.$toast.error("Erro ao recuperar parte dos dados.", "", {
              position: "topRight",
            });
          }
        })
        .finally(() => {
          this.$emit("updateLoadingDados", false);
          this.isFetching = false;
        });
    },
    getDadosTotais() {
      this.loadingPorChave.dadosTotais = true;
      return DashboardLnoService.getDadosTotaisIndicadoresLno(
        this.competencia,
        this.competencia,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosTotais = res;
        })
        .finally(() => {
          this.loadingPorChave.dadosTotais = false;
        });
    },
    getDadosTotaisCompetenciaAnterior() {
      // kpis
      return DashboardLnoService.getDadosTotaisIndicadoresLno(
        dayjs(this.competencia)
          .subtract(1, "month")
          .format("YYYY-MM"),
        dayjs(this.competencia)
          .subtract(1, "month")
          .format("YYYY-MM"),
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosTotaisCompetenciaAnterior = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosPorCompetencia() {
      this.loadingPorChave.dadosPorCompetencia = true;
      return DashboardLnoService.getDadosIndicadoresLnoPorPeriodo(
        this.competenciaDe,
        this.competenciaAte,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.eixoIndicadores = res.eixo || [];
          this.dadosPorCompetencia = res.series || {};

          this.chartOptionsQlpLno = this.getChartOptionsIndicadores("qlp");
          this.chartOptionsPlaLno = this.getChartOptionsIndicadores("pla");
          this.chartOptionsPmea15Lno = this.getChartOptionsIndicadores(
            "pmea15",
          );
          this.chartOptionsPmea30Lno = this.getChartOptionsIndicadores(
            "pmea30",
          );
          this.chartOptionsPmea45Lno = this.getChartOptionsIndicadores(
            "pmea45",
          );
          this.chartOptionsPat1Lno = this.getChartOptionsIndicadores("pat1");
          this.chartOptionsPat1QuantidadeLigacoesAtrasadas = this.getChartOptionsPatQuantidadeLigacoesAtrasadas(
            "pat1",
          );
          this.chartOptionsPat2Lno = this.getChartOptionsIndicadores("pat2");
          this.chartOptionsPat2QuantidadeLigacoesAtrasadas = this.getChartOptionsPatQuantidadeLigacoesAtrasadas(
            "pat2",
          );
          this.chartOptionsPat3Lno = this.getChartOptionsIndicadores("pat3");
          this.chartOptionsPat3QuantidadeLigacoesAtrasadas = this.getChartOptionsPatQuantidadeLigacoesAtrasadas(
            "pat3",
          );
          this.chartOptionsPat4Lno = this.getChartOptionsIndicadores("pat4");
          this.chartOptionsPat4QuantidadeLigacoesAtrasadas = this.getChartOptionsPatQuantidadeLigacoesAtrasadas(
            "pat4",
          );
          this.chartOptionsPSFP = this.getChartOptionsIndicadores("psfp");
        })
        .finally(() => {
          this.loadingPorChave.dadosPorCompetencia = false;
        });
    },
    getMetasKpisGeral() {
      return DashboardLnoService.getMetasKpisGeral(
        "2023-01",
        dayjs().format("YYYY-MM"),
      )
        .then((res) => {
          this.metasKpis = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosLocalizacaoSolicitacoes() {
      this.loadingPorChave.localizacaoSolicitacoes = true;
      return DashboardLnoService.getDadosLocalizacoesSolicitacoes(
        this.competencia,
        this.competencia,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosLocSolicitacoes = res;

          this.chartOptionsLocSolicitacoes = this.getPieChartOptions(
            this.getLocSolicitacoesChartSeriesData({
              urbano: this.dadosLocSolicitacoes.urbano.solicitacoes,
              rural: this.dadosLocSolicitacoes.rural.solicitacoes,
            }),
          );
          this.chartOptionsLocSolicitacoesEmAtraso = this.getPieChartOptions(
            this.getLocSolicitacoesChartSeriesData({
              urbano: this.dadosLocSolicitacoes.urbano.solicitacoes_em_atraso,
              rural: this.dadosLocSolicitacoes.rural.solicitacoes_em_atraso,
            }),
          );
        })
        .finally(() => {
          this.loadingPorChave.localizacaoSolicitacoes = false;
        });
    },
    getDadosTipologiasSolicitacoes() {
      this.loadingPorChave.tipologiasSolicitacoes = true;
      return DashboardLnoService.getDadosTipologiaSolicitacoes(
        this.competencia,
        this.competencia,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosTipologiasSolicitacoes = res;

          this.chartOptionsTipologiasSolicitacoes = this.getPieChartOptions(
            this.getTipologiasSolicitacoesChartSeriesData({
              tipo_1: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_1.solicitacoes,
              tipo_2: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_2.solicitacoes,
              tipo_3: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_3.solicitacoes,
              tipo_4: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_4.solicitacoes,
              orcamento: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_orcamento.solicitacoes,
            }),
          );
          this.chartOptionsTipologiasSolicitacoesEmAtraso = this.getPieChartOptions(
            this.getTipologiasSolicitacoesChartSeriesData({
              tipo_1: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_1.solicitacoes_em_atraso,
              tipo_2: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_2.solicitacoes_em_atraso,
              tipo_3: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_3.solicitacoes_em_atraso,
              tipo_4: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_tipo_4.solicitacoes_em_atraso,
              orcamento: this.dadosTipologiasSolicitacoes
                .tipologia_solicitacoes_orcamento.solicitacoes_em_atraso,
            }),
          );
        })
        .finally(() => {
          this.loadingPorChave.tipologiasSolicitacoes = false;
        });
    },
    getDadosSituacaoSolicitacoes() {
      this.loadingPorChave.situacaoSolicitacoes = true;
      return DashboardLnoService.getDadosSituacaoSolicitacoes(
        this.competencia,
        this.competencia,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosSituacaoSolicitacoes = res;

          this.chartOptionsSituacaoSolicitacoesObras = this.getPieChartOptions(
            this.getSituacaoSolicitacoesChartSeriesDataObras(
              this.dadosSituacaoSolicitacoes,
            ),
          );

          this.chartOptionsSituacaoSolicitacoesOrcamentos = this.getPieChartOptions(
            this.getSituacaoSolicitacoesChartSeriesDataOrcamentos(
              this.dadosSituacaoSolicitacoes,
            ),
          );
        })
        .finally(() => {
          this.loadingPorChave.situacaoSolicitacoes = false;
        });
    },
    getDadosQlpMultiSeries() {
      this.loadingPorChave.qlpMultiSeries = true;
      return DashboardLnoService.getDadosQlpMultiSeries(
        this.competenciaDe,
        this.competenciaAte,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.dadosQlpMultiSeries = res;

          const labels = this.getLabelsFromEixo(res.eixo);

          this.chartOptionsQlpMultiSeries = this.getStackedBarChartSeries(
            this.getQlpMultiSeriesChartSeries(this.dadosQlpMultiSeries),
            labels,
          );

          this.setDadosQla();
        })
        .finally(() => {
          this.loadingPorChave.qlpMultiSeries = false;
        });
    },
    setDadosQla() {
      const data = this.dadosQlpMultiSeries?.series?.obra_atrasada || [];
      const labels = this.getLabelsFromEixo(
        this.dadosQlpMultiSeries?.eixo || [],
      );

      this.dadosPorCompetencia["qla"] = data.reduce((acc, item) => {
        acc[item.label] = item.y;
        return acc;
      }, {});

      this.chartOptionsQla = this.buildChartOptions(
        [
          {
            name: "QLA",
            animation: false,
            data: data.filter(
              (val) =>
                val !== null &&
                val.y !== null &&
                Number.isFinite(val.y) &&
                val.y >= 0,
            ),
          },
        ],
        false,
        "qla",
        labels,
      );
    },
    getDadosPSFP() {
      return DashboardLnoService.getDadosPSFP(
        "2023-01",
        dayjs().format("YYYY-MM"),
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      );
    },
    setDadosPSFP() {
      this.dadosPorCompetencia["psfp"] = this.dadosPSFP.psfp;

      this.chartOptionsPSFP = this.getChartOptionsIndicadores("psfp");
    },
    getDadosQlt() {
      this.loadingPorChave.qlt = true;
      return DashboardLnoService.getDadosQlt(
        this.competenciaDe,
        this.competenciaAte,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          const labels = this.getLabelsFromEixo(res.eixo);

          this.chartOptionsQlt = this.getStackedBarChartSeries(
            this.getQltChartSeries(res),
            labels,
          );
        })
        .finally(() => {
          this.loadingPorChave.qlt = false;
        });
    },
    getDadosEntrantesConcluidos() {
      this.loadingPorChave.entrantesConcluidos = true;
      return DashboardLnoService.getDadosEntrantesConcluidosPorPeriodo(
        this.competenciaDe,
        this.competenciaAte,
        this.tipoCalculo,
        this.regionalSelecionadaId,
        this.tipoLocalizacao,
      )
        .then((res) => {
          this.eixoEntrantesConcluidos = res.eixo || [];
          this.dadosEntrantesConcluidos = res.series || {};
          this.setDadosEntrantesConcluidos();
        })
        .finally(() => {
          this.loadingPorChave.entrantesConcluidos = false;
        });
    },
    setDadosEntrantesConcluidos() {
      this.chartOptionsEntrantesConcluidos = this.getChartOptionsIndicadores(
        "entrantes_concluidos",
      );
    },
    getChartOptionsIndicadores(indicador, showLegend = true) {
      if (indicador === "entrantes_concluidos") {
        const labels = this.getLabelsFromEixo(this.eixoEntrantesConcluidos);

        return this.buildChartOptions(
          [
            this.buildDataSeriesFromBackend(
              "Entrantes",
              this.dadosEntrantesConcluidos?.entrantes || [],
            ),
            this.buildDataSeriesFromBackend(
              "Concluídos",
              this.dadosEntrantesConcluidos?.concluidos || [],
            ),
          ],
          showLegend,
          indicador,
          labels,
        );
      }

      const labels = this.getLabelsFromEixo(this.eixoIndicadores);
      const nome = this.getNomeFromEixo(this.eixoIndicadores);

      return this.buildChartOptions(
        [
          this.buildDataSeriesFromBackend(
            nome,
            this.dadosPorCompetencia?.[indicador] || [],
          ),
        ],
        showLegend,
        indicador,
        labels,
      );
    },

    getChartOptionsPatQuantidadeLigacoesAtrasadas(indicador) {
      const labels = this.getLabelsFromEixo(this.eixoIndicadores);
      const nome = this.getNomeFromEixo(this.eixoIndicadores);

      const chartSeries = [
        {
          name: nome,
          type: "spline",
          animation: false,
          data: (
            this.dadosPorCompetencia?.[`qtd_ligacoes_atrasadas_${indicador}`] ||
            []
          ).filter((val) => val !== null && val.y !== null && val.y >= 0),
        },
      ];

      return {
        chart: {
          type: "column",
          zooming: { type: "x" },
          height: 400,
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        exporting: this.exportingOptions,
        tooltip: {
          shared: true,
          followPointer: true,
        },
        plotOptions: {
          series: {
            animation: false,
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
          column: {
            pointPadding: 0.1,
            groupPadding: 0.1,
          },
        },
        xAxis: {
          categories: labels,
          crosshair: true,
          title: {
            text: "Competência",
          },
        },
        yAxis: {
          title: { text: "Quantidade de ligações atrasadas" },
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: chartSeries,
      };
    },

    buildChartSeries(indicador) {
      if (indicador === "entrantes_concluidos") {
        return [
          this.buildDataSeries(
            "Entrantes",
            this.categoriesResultadoAtual,
            "entrantes",
          ),
          this.buildDataSeries(
            "Concluídos",
            this.categoriesResultadoAtual,
            "concluidos",
          ),
        ];
      }

      return [
        this.buildDataSeries(
          this.categoriesResultadoAtual[0].split("/")[1],
          this.categoriesResultadoAtual,
          indicador,
        ),
        this.buildDataSeries(
          this.categoriesResultadoAnterior[0].split("/")[1],
          this.categoriesResultadoAnterior,
          indicador,
        ),
      ];
    },

    buildDataSeries(name, categories, indicador) {
      return {
        name,
        animation: false,
        data: categories
          .map((category, index) => {
            return category in this.dadosPorCompetencia[indicador]
              ? {
                  x: index,
                  y: Number(this.dadosPorCompetencia[indicador][category]),
                }
              : { x: index, y: 0 };
          })
          // aceitar zeros e garantir que o valor seja numérico finito
          .filter(
            (val) =>
              val !== null &&
              val.y !== null &&
              Number.isFinite(val.y) &&
              val.y >= 0,
          ),
      };
    },

    buildChartOptions(
      series,
      showLegend,
      indicador,
      categories = this.categoriesResultadoAtual,
    ) {
      return {
        chart: {
          type: "column",
          zooming: { type: "x" },
          height: 400,
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: showLegend },
        exporting: this.exportingOptions,
        tooltip: {
          shared: true,
          followPointer: true,
        },
        plotOptions: {
          series: {
            animation: false,
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
        },
        xAxis: {
          categories,
          crosshair: true,
          labels: {
            rotation: -45,
            style: {
              fontSize: "10px",
            },
          },
        },
        yAxis: [
          {
            title: { text: null },
          },
          {
            title: { text: null },
            opposite: true,
          },
        ],
        lang: {
          noData: "Sem dados para exibição",
        },
        series,
      };
    },
    getPieChartOptions(seriesData) {
      const data = (seriesData || [])
        .map((p) => ({
          name: p.name,
          y: Number(p.y ?? 0),
        }))
        .filter((p) => Number.isFinite(p.y));
      return {
        chart: {
          type: "pie",
          height: 250,
          animation: false,
        },
        exporting: this.exportingOptions,
        // colors: [],
        plotOptions: {
          series: {
            animation: false,
          },
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              distance: 30,
              formatter: function() {
                return `${this.point.name}: ${parseFloat(
                  this.point.y,
                ).toLocaleString("pt-BR")}`;
                // return parseFloat(this.point.y).toLocaleString('pt-BR')
              },
            },
            showInLegend: true,
          },
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: false },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [
          {
            name: "Valor",
            colorByPoint: true,
            innerSize: "75%",
            animation: false,
            data,
          },
        ],
      };
    },
    getLocSolicitacoesChartSeriesData(dados) {
      return [
        { name: "Urbano", y: dados.urbano },
        { name: "Rural", y: dados.rural },
      ];
    },
    getTipologiasSolicitacoesChartSeriesData(dados) {
      return [
        { name: "Tipo 1", y: dados.tipo_1 },
        { name: "Tipo 2", y: dados.tipo_2 },
        { name: "Tipo 3", y: dados.tipo_3 },
        { name: "Tipo 4", y: dados.tipo_4 },
      ];
    },
    getSituacaoSolicitacoesChartSeriesDataObras(dados) {
      return [
        { name: "Obra no Prazo", y: dados.obra_no_prazo },
        { name: "Obra Atrasada", y: dados.obra_atrasada },
        { name: "Obra Suspensa", y: dados.obra_suspensa },
      ];
    },
    getSituacaoSolicitacoesChartSeriesDataOrcamentos(dados) {
      return [
        { name: "Orçamento no Prazo", y: dados.orcamento_no_prazo },
        { name: "Orçamentos Atrasados", y: dados.orcamentos_atrasados },
        { name: "Orçamento Suspensos", y: dados.orcamentos_suspensos },
      ];
    },
    getStackedBarChartSeries(
      series,
      categories = this.categoriesResultadoAtual,
    ) {
      return {
        chart: {
          type: "column",
          zooming: {
            type: "x",
          },
          height: 400,
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        tooltip: {
          shared: true,
        },
        plotOptions: {
          series: {
            animation: false,
          },
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
            },
          },
        },
        xAxis: {
          categories,
          crosshair: true,
          title: {},
        },
        yAxis: {
          title: { text: null },
          stackLabels: {
            enabled: true,
          },
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: series,
        exporting: this.exportingOptions,
      };
    },
    getQlpMultiSeriesChartSeries(dados) {
      const seriesInfo = [
        { title: "Orçamentos Atrasados", varName: "orcamentos_atrasados" },
        { title: "Orçamento no Prazo", varName: "orcamento_no_prazo" },
        { title: "Obra Atrasada", varName: "obra_atrasada" },
        { title: "Obra no Prazo", varName: "obra_no_prazo" },
      ];

      return seriesInfo.map((serie) => ({
        name: serie.title,
        color: serie.color,
        animation: false,
        data: (dados?.series?.[serie.varName] || []).filter(
          (val) =>
            val !== null &&
            val.y !== null &&
            Number.isFinite(val.y) &&
            val.y >= 0,
        ),
      }));
    },
    getQltChartSeries(dados) {
      const seriesInfo = [
        {
          title: "Ligações com obra suspensas",
          varName: "lig_obra_suspensas",
          color: this.$vuetify.theme.themes.light.primary,
        },
        {
          title: "Ligações com obra pendentes",
          varName: "lig_obra_pendentes",
          color: this.$vuetify.theme.themes.light.success,
        },
      ];

      return seriesInfo.map((serie) => ({
        name: serie.title,
        type: "column",
        stacking: "normal",
        animation: false,
        data: (dados?.series?.[serie.varName] || []).filter(
          (val) =>
            val !== null &&
            val.y !== null &&
            Number.isFinite(val.y) &&
            val.y >= 0,
        ),
      }));
    },
    parseSvgSize(svgString) {
      // tenta extrair viewBox ou width/height
      const viewBoxMatch = svgString.match(/viewBox=\"([^\"]+)\"/);
      if (viewBoxMatch) {
        const parts = viewBoxMatch[1].split(/\s+/).map(Number);
        if (parts.length === 4) return { width: parts[2], height: parts[3] };
      }
      const widthMatch = svgString.match(/width=\"([0-9.]+)(px)?\"/);
      const heightMatch = svgString.match(/height=\"([0-9.]+)(px)?\"/);
      if (widthMatch && heightMatch) {
        return {
          width: Number(widthMatch[1]),
          height: Number(heightMatch[1]),
        };
      }
      // fallback
      return { width: 800, height: 400 };
    },
    svgToPngBase64(svgString, scale = 1) {
      return new Promise((resolve, reject) => {
        try {
          const { width, height } = this.parseSvgSize(svgString);
          const svgBlob = new Blob([svgString], {
            type: "image/svg+xml;charset=utf-8",
          });
          const url = URL.createObjectURL(svgBlob);
          const img = new Image();

          // ensure no cross-origin issues (SVGs inline won't have CORS)
          img.onload = function() {
            try {
              const canvas = document.createElement("canvas");
              canvas.width = Math.round(width * scale);
              canvas.height = Math.round(height * scale);
              const ctx = canvas.getContext("2d");

              // white background (optional)
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(0, 0, canvas.width, canvas.height);

              // desenha imagem (redimensiona automaticamente via width/height do canvas)
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              const dataUrl = canvas.toDataURL("image/png");
              URL.revokeObjectURL(url);
              resolve(dataUrl.split(",")[1]); // retorna base64 sem prefixo
            } catch (err) {
              URL.revokeObjectURL(url);
              reject(err);
            }
          };

          img.onerror = function(e) {
            URL.revokeObjectURL(url);
            reject(new Error("Erro ao carregar SVG como imagem."));
          };

          img.src = url;
        } catch (err) {
          reject(err);
        }
      });
    },
    getChartTitle(refName) {
      // Mapeamento dos títulos dos gráficos
      const chartTitles = {
        chartOptionsSituacaoSolicitacoesObras:
          "Situação das Solicitações - Obras",
        chartOptionsSituacaoSolicitacoesOrcamentos:
          "Situação das Solicitações - Orçamentos",
        chartOptionsTipologiasSolicitacoes: "Tipologias das Solicitações",
        chartOptionsLocSolicitacoes: "Localização das Obras",
        chartOptionsLocSolicitacoesEmAtraso: "Localização das Obras em Atraso",
        chartOptionsTipologiasSolicitacoesEmAtraso:
          "Tipologias das Solicitações em Atraso",
        chartOptionsQlpLno:
          "QLP - Qtde. de Ligações com obra pendentes não suspensas",
        chartOptionsPlaLno: "PLA - Percentual de ligações com obra atrasadas",
        chartOptionsQla: "QLA - Qtde. de Ligações Atrasadas",
        chartOptionsQlt:
          "QLT - Qtde. de Ligações Totais (pendentes + suspensas)",
        chartOptionsPat1Lno: "PAT1 - Prazo Médio de Lig. Atrasada do Tipo 1",
        chartOptionsPat1QuantidadeLigacoesAtrasadas:
          "PAT1 - Quantidade de ligações atrasadas do Tipo 1",
        chartOptionsPat2Lno: "PAT2 - Prazo Médio de Lig. Atrasada do Tipo 2",
        chartOptionsPat2QuantidadeLigacoesAtrasadas:
          "PAT2 - Quantidade de ligações atrasadas do Tipo 2",
        chartOptionsPat3Lno: "PAT3 - Prazo Médio de Lig. Atrasada do Tipo 3",
        chartOptionsPat3QuantidadeLigacoesAtrasadas:
          "PAT3 - Quantidade de ligações atrasadas do Tipo 3",
        chartOptionsPat4Lno: "PAT4 - Prazo Médio de Lig. Atrasada do Tipo 4",
        chartOptionsPat4QuantidadeLigacoesAtrasadas:
          "PAT4 - Quantidade de ligações atrasadas do Tipo 4",
        chartOptionsPmea15Lno:
          "PMEA15 - Prazo Médio de Estudos Atrasados (15 dias)",
        chartOptionsPmea30Lno:
          "PMEA30 - Prazo Médio de Estudos Atrasados (30 dias)",
        chartOptionsPmea45Lno:
          "PMEA45 - Prazo Médio de Estudos Atrasados (45 dias)",
        chartOptionsEntrantesConcluidos: "Entrantes vs Concluídos",
        chartOptionsPSFP:
          "PSFP - Percentual de Serviços Atendidos Após o Prazo Regulatório",
      };

      return chartTitles[refName] || this.getDefaultChartTitle(refName);
    },
    getDefaultChartTitle(refName) {
      // Fallback para títulos não mapeados
      return refName
        .replace("chartOptions", "")
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    },
    resolveChartObjFromRefName(refName) {
      const refValue = this.$refs[refName];
      if (!refValue) return null;

      const components = Array.isArray(refValue) ? refValue : [refValue];

      for (const cmp of components) {
        const chartObj =
          cmp?.chart ||
          cmp?.chartRef?.chart ||
          cmp?.$refs?.highcharts?.chart ||
          cmp?.$refs?.[refName]?.chart ||
          cmp?.$children?.find((child) => child?.chart)?.chart;

        if (chartObj) return chartObj;
      }

      return null;
    },
    getChartSvgFromOptions(refName) {
      const options = this[refName];
      if (!options || Object.keys(options).length === 0) return null;

      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.left = "-10000px";
      container.style.top = "0";
      container.style.width = "1400px";
      container.style.height = "900px";
      container.style.pointerEvents = "none";
      container.style.opacity = "0";
      document.body.appendChild(container);

      let chart = null;
      try {
        const mergedOptions = Highcharts.merge({}, options, {
          chart: Highcharts.merge({}, options.chart || {}, {
            backgroundColor: "white",
          }),
        });
        chart = Highcharts.chart(container, mergedOptions);
        return chart.getSVG({
          chart: { backgroundColor: "white" },
        });
      } catch (err) {
        console.warn("Erro ao gerar SVG a partir das options", refName, err);
        return null;
      } finally {
        if (chart) {
          chart.destroy();
        }
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      }
    },
    formatCompetencia(competencia) {
      // Converte formato YYYY-MM para MM/YYYY (padrão brasileiro)
      if (competencia && competencia.includes("-")) {
        const [year, month] = competencia.split("-");
        return `${month}/${year}`;
      }
      return competencia;
    },

    async getRegionalSigla(regionalId) {
      try {
        if (!regionalId || regionalId === 0) {
          return "Todas";
        }

        // Busca todas as regionais e encontra a específica pelo ID
        const regionais = await MunicipiosService.getRegionais();
        const regional = regionais.find((r) => r.id === regionalId);

        const sigla = regional
          ? regional.sigla || regional.nome || "N/A"
          : "N/A";
        return sigla;
      } catch (err) {
        console.warn("Erro ao obter sigla da regional:", err);
        return "N/A";
      }
    },
    async exportDashboardToPdfDompdf() {
      this.$emit("updateExportingPdfVisaoAneel", true);
      this.$toast.info("Preparando seu arquivo para download.", "", {
        position: "topRight",
      });

      try {
        const chartsPayload = [];

        for (const refName of this.chartRefNames) {
          const chartObj = this.resolveChartObjFromRefName(refName);
          let svg =
            chartObj?.getSVG?.({
              chart: { backgroundColor: "white" },
            }) || this.getChartSvgFromOptions(refName);
          let pngBase64 = null;

          if (svg) {
            try {
              pngBase64 = await this.svgToPngBase64(svg, 2);
            } catch (err) {
              console.warn("Erro ao converter", refName, err);
            }
          }

          // Extrai o título do gráfico do DOM
          const chartTitle = this.getChartTitle(refName);

          chartsPayload.push({
            ref: refName,
            svg,
            png: pngBase64,
            title: chartTitle,
          });
        }

        const formattedCompetencia = this.formatCompetencia(this.competencia);

        // Dados para a folha de capa
        const coverData = {
          competencia: formattedCompetencia,
          regionalSigla: await this.getRegionalSigla(
            this.regionalSelecionadaId,
          ),
          empresaSigla: this.$store.getters.getCompanySigla || "N/A",
        };

        const payload = {
          competencia: formattedCompetencia,
          tipoCalculo: this.tipoCalculo,
          tipoLocalizacao: this.tipoLocalizacao,
          regionalSelecionadaId: this.regionalSelecionadaId,
          dadosTotais: this.dadosTotais,
          chartOrder: this.chartRefNames,
          charts: chartsPayload,
          coverData: coverData,
        };

        const pdfBlob = await DashboardLnoService.exportDashboardPdfDompdf(
          payload,
        );

        const url = URL.createObjectURL(
          new Blob([pdfBlob], { type: "application/pdf" }),
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `Dashboard_LNO_Visao_ANEEL_${this.$store.getters.getCompanySigla}_${this.competencia}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
        this.$toast.error("Ocorreu um erro ao gerar PDF", "", {
          position: "topRight",
        });
      } finally {
        this.$emit("updateExportingPdfVisaoAneel", false);
      }
    },
  },
  watch: {
    activatedTab() {
      this.scheduleGetDados();
    },
    competencia() {
      this.scheduleGetDados();
    },
    tipoCalculo() {
      this.scheduleGetDados();
    },
    tipoLocalizacao() {
      this.scheduleGetDados();
    },
    regionalSelecionadaId() {
      this.scheduleGetDados();
    },
  },
};
</script>

<style></style>
